import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
  pagination,
} from "../../../store/administration/selectors/ubications";

const Ubications = lazy(() => import("./Ubications"));

const mapStateToProps = (state) => ({
  isLoading: loading(state),
  ubications: data(state),
  pagination: pagination(state),
});

export default connect(mapStateToProps)(Ubications);
